import { useMemo } from "react";

import { router } from "@/router";
import { create } from "@bufbuild/protobuf";
import { RouterProvider } from "@tanstack/react-router";
import { useAuth } from "@workos-inc/authkit-react";

import { GetCurrentUserRequestSchema } from "@gx/ts-contracts/services/management/api/user_pb";

import FullScreenLoader from "@/layouts/FullScreenLoader";

import { useGetCurrentUserQuery } from "@/api/queries/users";

export const App = () => {
  const workosAuth = useAuth();
  const {
    data: currentUser,
    isLoading: isLoadingCurrentUser,
    isError: isErrorCurrentUser,
  } = useGetCurrentUserQuery({
    input: create(GetCurrentUserRequestSchema, {}),
    options: {
      enabled: !!workosAuth.user?.id,
    },
  });

  // Memoize router context to prevent re-renders on token refresh.
  // Only include the stable parts of workosAuth that routes actually need.
  const routerContext = useMemo(
    () => ({ workosAuth, currentUser }),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally exclude workosAuth object to avoid re-render on token refresh
    [workosAuth.user?.id, workosAuth.organizationId, workosAuth.isLoading, currentUser],
  );

  if (workosAuth.isLoading || isLoadingCurrentUser || isErrorCurrentUser) {
    return <FullScreenLoader />;
  }

  return <RouterProvider router={router} context={routerContext} />;
};

export default App;
